import { StationsDB } from '../data/stations.js';
import { POIsDB } from '../data/pois.js';

export const StationMap = StationsDB.reduce((map, e) => { map[e.i] = e; return map; }, {});

export const POIMap = POIsDB.reduce((map, e) => { map[e.i] = e; return map; }, {});
